import { createContext, useContext } from "react";

/**
 * ReleaseNotesContext — exposes the single open-state owner (useReleaseNotes,
 * run once in WorkspaceApp) so the nav-bar account menu can re-open the "What's New"
 * overlay from anywhere in v2. Value: { open, openNotes, dismiss, version }.
 * null when the release-notes feature flag is off.
 */
export const ReleaseNotesContext = createContext(null);

export const useReleaseNotesContext = () => useContext(ReleaseNotesContext);

export default ReleaseNotesContext;
